import React, { useRef, useState } from "react";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useParams } from "react-router-dom";
import MuiButton from "../../../shares/MuiButton";
import { toast } from "react-toastify";
import useFetch from "../../../../context/useFetch";
import { fixNumbers } from "../../../../utils";
import moment from "jalali-moment";
import { useUserData } from "../../../../context/UserDataContext";

const AdminPrintProviderNewOrder = (props) => {
  const navigate = useNavigate();
  const userData = useUserData();
  const componentRef = useRef();
  const { unique_id, store_name, date } = useParams();
  const [newOerdersList, setNewOerdersList] = useState({ results: [] });

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 1000,
    count: 0,
  });

  const adminGetCustomerCreateOrderApi = useFetch({
    method: "get",
    url: `User_Service/${userData.username}/admin_get_waiting_provider_request`,
    params: {
      code: unique_id == "null" ? null : fixNumbers(unique_id),
      store_name: store_name == "null" ? null : store_name,
      date: date == "null" ? null : date,
    },
    trigger: true,
    pagination: paginationPageInfo,
    setter: setNewOerdersList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const closeTab = () => {
    window.opener = null;
    window.open("", "_self");
    window.close();
  };
  return (
    <>
      <div className="my-4">
        <div className="flex justify-between items-center mx-8 mb-4">
          <span className="text-sm">برای دانلود فایل PDF کلیک کنید.</span>
          <div className="flex">
            <ReactToPrint
              trigger={() => {
                return (
                  <MuiButton
                    variant="contained"
                    color="primary"
                    text="دانلود فایل PDF"
                    size="small"
                    //    icon={<ModeEditIcon />}
                  />
                );
              }}
              content={() => componentRef.current}
            />
            <div className="mr-4">
              <MuiButton
                onClick={() => closeTab()}
                variant="outlined"
                color="secondary"
                text="بازگشت"
                size="small"
                icon={<ArrowBackIcon />}
              />
            </div>
          </div>
        </div>

        <div
          className="printTable"
          ref={componentRef}
          style={{ direction: "rtl" }}
        >
          <div className=" bg-myblue-100 px-8 py-4 text-center">
            <span className="font-bold text-yellow-200 text-lg">
              فروشگاه زرسان
            </span>
          </div>
          <div className="text-center mt-8">
            <span className="font-bold">سفارش های جدید</span>
          </div>

          <div className="border rounded-md mt-4 overflow-hidden mx-2">
            <div className="flex justify-between">
              <div className="basis-1/2  text-center py-1 ">
                <span className="text-sm text-myblue-100">ردیف</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">تولیدکننده</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">سند</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">تاریخ ثبت سفارش</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">وزن</span>
              </div>
            </div>
          </div>

          {newOerdersList.results.map((item, index) => {
            return [
              <>
                <div className="border rounded-md overflow-hidden mx-2">
                  <div className="flex justify-between">
                    <div className="basis-1/2  text-center py-1  border-r">
                      <span className="text-sm text-myblue-100">
                        {index + 1}
                      </span>
                    </div>
                    <div className="basis-1/2  text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.name}
                      </span>
                    </div>
                    <div className="basis-1/2  text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.unique_id}
                      </span>
                    </div>
                    <div className="basis-1/2  text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {moment(item.created_at, "YYYY/MM/DD")
                          .locale("fa")
                          .format("YYYY/MM/DD")}
                      </span>
                    </div>
                    <div className="basis-1/2  text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.total}
                      </span>
                    </div>
                  </div>
                </div>
              </>,
            ];
          })}
        </div>
      </div>
    </>
  );
};

export default AdminPrintProviderNewOrder;
